import { render } from "./WarehouseDatatableTDMaterialTitle.vue?vue&type=template&id=61193881"
import script from "./WarehouseDatatableTDMaterialTitle.vue?vue&type=script&lang=js"
export * from "./WarehouseDatatableTDMaterialTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__